/* eslint-disable @typescript-eslint/ban-ts-comment */
import { BigNumber } from "@ethersproject/bignumber";

import { Decimal } from "@liquity/lib-base";
import { ethers } from "ethers";
export const numberify = (bigNumber: BigNumber): number => bigNumber.toNumber();

export const decimalify = (bigNumber: BigNumber): Decimal =>
  Decimal.fromBigNumberString(bigNumber.toHexString());

export const panic = <T>(e: unknown): T => {
  throw e;
};

export type Resolved<T> = T extends Promise<infer U> ? U : T;
export type ResolvedValues<T> = { [P in keyof T]: Resolved<T[P]> };

export const promiseAllValues = <T>(object: T): Promise<ResolvedValues<T>> => {
  // @ts-ignore
  const keys = Object.keys(object);

  // @ts-ignore
  return Promise.all(Object.values(object)).then(values =>
    Object.fromEntries(values.map((value, i) => [keys[i], value]))
  ) as Promise<ResolvedValues<T>>;
};

export const convertBigNumberValueToNumber = (
  weiBalance: number | string,
  decimal: number | string
): string | number => {
  const res = ethers.utils.formatUnits(weiBalance, decimal).toString();
  return res;
};
